import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";
import Http from '../../../Http';

class Embalaje extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'embalaje/one', saveUrl: 'embalaje/save', backUrl: '/Catalogo/Embalajes' },
      new Form([
        Form.Field('text', 'embalaje', 'Clave', '', [Validators.required], 4),
        Form.Field('text', 'embalaje_nombre', 'Descripcion', '', [Validators.required, Validators.maxLength(250)], 4),
        Form.Field('select', 'id_embalaje_grupo', 'Grupo de Embalaje', '', [Validators.required], 4),
      ], ['Guardar'], 'Embalaje'), this.formData
    )
    if (this.props.match.params.id)
      this.LoadPreds()
  }

  formData = async (form) => {
    const Res = await Http.get('embalaje-grupo/all');

    if (!Res.error) {
      const cargosTipos = Form.FieldOptions(form, 'id_embalaje_grupo', Res.data, 'id', 'grupo');
      return cargosTipos;
    }
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(Embalaje)
